import { render, staticRenderFns } from "./CustomerSearchForm.vue?vue&type=template&id=871742e4&scoped=true"
import script from "./CustomerSearchForm.vue?vue&type=script&lang=js"
export * from "./CustomerSearchForm.vue?vue&type=script&lang=js"
import style0 from "./CustomerSearchForm.vue?vue&type=style&index=0&id=871742e4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871742e4",
  null
  
)

export default component.exports